import { AboutContent } from "./AboutContent";
import { Dialog } from "@src/components/Dialog";
import {
  ShareDialogs,
  type ShareCopyOutcome,
  type ShareDialog,
} from "@src/features/sharing/ShareDialogs";
import type { Translate } from "@src/i18n/translate";

export type AppDialog = "about" | "reset" | ShareDialog | null;

interface Props {
  dialog: AppDialog;
  setDialog: (dialog: AppDialog) => void;
  t: Translate;
  version: string;
  shareLink: string;
  shareCopyOutcome: ShareCopyOutcome;
  onReset: () => void;
  onRecoverInvalidShare: () => void;
  returnFocus?: HTMLElement | null;
}

export function AppDialogs({
  dialog,
  setDialog,
  t,
  version,
  shareLink,
  shareCopyOutcome,
  onReset,
  onRecoverInvalidShare,
  returnFocus,
}: Props) {
  const close = () => {
    setDialog(null);
  };
  return (
    <>
      <Dialog
        open={dialog === "about"}
        onClose={close}
        className="about-dialog"
        labelledBy="about-title"
        returnFocus={returnFocus}
      >
        <AboutContent t={t} version={version} onClose={close} />
      </Dialog>
      <ShareDialogs
        dialog={dialog === "share" || dialog === "share-error" ? dialog : null}
        setDialog={setDialog}
        t={t}
        shareLink={shareLink}
        shareCopyOutcome={shareCopyOutcome}
        onRecoverInvalidShare={onRecoverInvalidShare}
        returnFocus={returnFocus}
      />
      <Dialog
        open={dialog === "reset"}
        onClose={close}
        className="reset-workspace-dialog"
        labelledBy="reset-workspace-title"
        returnFocus={returnFocus}
      >
        <div className="reset-workspace-content">
          <h1 id="reset-workspace-title">{t("resetWorkspaceTitle")}</h1>
          <p>{t("resetWorkspaceDescription")}</p>
          <div className="reset-workspace-actions">
            <button type="button" onClick={close}>
              {t("cancel")}
            </button>
            <button className="danger-button" type="button" onClick={onReset}>
              {t("confirmResetWorkspace")}
            </button>
          </div>
        </div>
      </Dialog>
    </>
  );
}
